import { ASCEND } from "../constant/sort";

export const nullSort = (a, b, sortDirection, sortFunc) => {
  if (!a && !b) return 0;
  else if (!a) return sortDirection === ASCEND ? 1 : -1;
  else if (!b) return sortDirection === ASCEND ? -1 : 1;
  return sortFunc();
};

export const dateSort = (a, b, sortDirection) => {
  return nullSort(a, b, sortDirection, () => {
    return Date.parse(a) < Date.parse(b) ? -1 : 1;
  });
};

export const stringSort = (a, b, sortDirection) => {
  return nullSort(a, b, sortDirection, () => {
    a = typeof a === "string" ? a.toLowerCase() : a.toString();
    b = typeof b === "string" ? b.toLowerCase() : b.toString();

    return a.localeCompare(b);
  });
};
